function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
  fill: "#2F66E3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.452 35.3324C50.6003 37.2122 52.3267 43.5038 53.4392 48.7211C51.2909 51.4449 48.6822 53.7467 45.6899 55.5498V41.1636C45.6899 39.3605 44.2321 37.9027 42.429 37.9027H17.4162C15.6131 37.9027 14.1553 39.3605 14.1553 41.1636V55.5114C11.2014 53.67 8.59267 51.3682 6.44434 48.6444C7.55687 43.4654 9.28321 37.2122 11.4315 35.3324C12.9022 34.0535 14.7459 33.2809 16.9183 32.3706C17.3526 32.1886 17.8 32.0011 18.2602 31.803C15.5748 29.8465 14.117 27.6598 14.117 26.7007C14.117 24.7825 20.6387 7.17383 30.1911 7.17383C39.7819 7.17383 46.5339 25.3963 46.5339 27.1227C46.5339 27.9667 44.9226 30.0766 42.007 31.9564C42.374 32.1153 42.7332 32.2679 43.0842 32.417C45.1916 33.3123 47.0051 34.0828 48.452 35.3324ZM37.8638 28.7339C38.5159 28.7339 39.2448 27.6214 39.5517 26.1636C39.6285 25.8951 39.6668 25.6265 39.5901 25.358C36.7896 24.5907 33.2986 24.0536 29.8842 24.0536C26.2781 24.0536 22.787 24.6291 20.1783 25.4731L20.2934 26.1636C20.6387 27.6214 21.3676 28.6956 21.9814 28.7339C23.1707 32.9539 26.2397 35.9846 29.9226 35.9846C33.6055 35.9846 36.7129 32.9539 37.8638 28.7339Z",
  fill: "#2F66E3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.0457 43.8625L27.9235 50.9547L28.9768 51.4184L32.099 44.3262L31.0457 43.8625Z",
  fill: "#2F66E3"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.322 47.3783L26.9307 44.7696L27.7747 45.5753L25.9716 47.3783L27.7363 49.143L26.8924 49.9487L24.322 47.3783Z",
  fill: "#2F66E3"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.6468 45.5753L33.4524 44.7696L36.0611 47.3783L33.5291 49.9487L32.6851 49.143L34.4498 47.3783L32.6468 45.5753Z",
  fill: "#2F66E3"
});

var SvgStorageTypeV1 = function SvgStorageTypeV1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStorageTypeV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storageTypeV1.2b193b9d.svg";
export { ForwardRef as ReactComponent };